/* global bcejwt */
import VueCookies from "vue-cookies";

const cookieOptions = { path: "/", domain: ".deascuola.it", secure: true };
const sessionCookieName = "sessionId";
const historyCookieName = "hubEncryptedUser";
const loginCookieName = "bcejwt.loginToken";

export default function userLogout() {
  VueCookies.remove(historyCookieName, cookieOptions);
  VueCookies.remove(sessionCookieName, cookieOptions);
  VueCookies.remove(loginCookieName, cookieOptions);
  bcejwt.logout();
  localStorage.removeItem("profile");
  localStorage.removeItem(sessionCookieName);
}
